export default "__VITE_ASSET__64180aaa__"